
import { useState } from 'react';
import Button from '../base/Button';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d3i08893290jal8uctlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitMessage('Successfully subscribed to newsletter!');
        setEmail('');
      } else {
        setSubmitMessage('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Impact', href: '#impact' },
    { name: 'Media', href: '#media' },
    { name: 'Contact', href: '#contact' }
  ];

  const resources = [
    { name: 'Blog', href: '#' },
    { name: 'Insights', href: '#' },
    { name: 'Publications', href: '#' },
    { name: 'Speaking', href: '#' },
    { name: 'Ventures', href: '#' }
  ];

  const socialLinks = [
    { name: 'LinkedIn', icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/in/valerie-labi-27217936/' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Valerie Labi
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Stay updated on Valerie's latest insights, projects, and transformative initiatives.
            </p>
            
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-3" data-readdy-form id="newsletter">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg bg-gray-800 text-white placeholder-gray-400 border border-gray-700 focus:border-teal-500 focus:outline-none"
                required
              />
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </Button>
            </form>
            
            {submitMessage && (
              <p className={`mt-2 text-sm ${submitMessage.includes('Successfully') ? 'text-green-400' : 'text-red-400'}`}>
                {submitMessage}
              </p>
            )}
            
            <p className="text-gray-400 text-sm mt-3">
              By subscribing, you agree to our privacy policy and consent to receive updates.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              {resources.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-wrap items-center gap-6 mb-4 md:mb-0">
              <p className="text-gray-400">© 2024 Valerie Labi. All rights reserved.</p>
              <div className="flex gap-4">
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Privacy Policy</a>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Terms of Service</a>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Cookies Settings</a>
                <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Website Builder</a>
              </div>
            </div>
            
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
